import React, { useState } from 'react';
import { APIProvider, Map, Marker, InfoWindow } from '@vis.gl/react-google-maps';
import { useAtom } from 'jotai';
import { carLocationsAtom } from '../atoms/carLocationsAtom';
import { mapZoomAtom } from '../atoms/carLocationsAtom';
import { mapCenterAtom } from '../atoms/carLocationsAtom';
import { Polygon } from '../polygon';
import { CarLocate } from '../atoms/carLocationsAtom';

const polygons = [
  // Motor Cross area
  [
    { lng: -71.4600557, lat: 43.358903 },
    { lng: -71.4599859, lat: 43.3570504 },
    { lng: -71.4575398, lat: 43.3570582 },
    { lng: -71.4575666, lat: 43.3589537 },
    { lng: -71.4600557, lat: 43.358903 }, 
  ],
  // Brake Test area
  [
    { lng: -71.4601947, lat: 43.3651116 },
    { lng: -71.4604307, lat: 43.3645714 },
    { lng: -71.4589636, lat: 43.364199 },
    { lng: -71.4587516, lat: 43.3647508 },
    { lng: -71.4601947, lat: 43.3651116 },
  ],
  // Acceleration Test area
  [
    { lng: -71.461201, lat: 43.3647126 },
    { lng: -71.4627996, lat: 43.3612338 },
    { lng: -71.4624026, lat: 43.3611246 },
    { lng: -71.4607933, lat: 43.3646112 },
    { lng: -71.461201, lat: 43.3647126 }, 
  ]
];

const colors = ['firebrick', 'goldenrod', 'darkblue'];

const TestMap = () => {
  const [carLocations] = useAtom(carLocationsAtom);
  const [testMapCenter] = useAtom(mapCenterAtom);
  const [zoomState] = useAtom(mapZoomAtom);
  const [selectedCar, setSelectedCar] = useState<CarLocate | null>(null);

  const handleMarkerClick = (carLocation: CarLocate) => {
     setSelectedCar(selectedCar === carLocation ? null : carLocation);
  };


  return (
    <APIProvider apiKey="AIzaSyDYZA7VHWtg3w6W0W1QDwkHAoo_MuQV_IU">
      <Map
        key={JSON.stringify(testMapCenter)}
        style={{ width: '600px', height: '400px' }}
        defaultCenter={testMapCenter}
        defaultZoom={zoomState.zoom}
        mapId='56128e7cf3900e81'
      >
        {polygons.map((path, index) => (
          <Polygon
            key={index}
            paths={path}
            strokeColor={colors[index]} 
            fillColor={colors[index]} 
            strokeOpacity={0.8}
            strokeWeight={2}
            fillOpacity={0.35}
          />
        ))}
        {carLocations?.map((carLocation, index) => (
          <React.Fragment key={index}>
            <Marker
              position={{ lat: carLocation.Lat, lng: carLocation.Long }}
              onClick={() => handleMarkerClick(carLocation)}
            />
            {selectedCar === carLocation && (
              <InfoWindow
                position={{ lat: carLocation.Lat, lng: carLocation.Long }}
                onCloseClick={() => setSelectedCar(null)}
              >
                <div>
                  <p>CarNumber: {carLocation.CarNumber}</p>
                  <p>Coordinates: {carLocation.Lat}, {carLocation.Long}</p>
                </div>
              </InfoWindow>
            )}
          </React.Fragment>
        ))}
      </Map>
    </APIProvider>
  );
};

export default TestMap;